import React, { useEffect } from 'react'
import { get, pick } from 'lodash-es'
import { useBeforeTransform, useTbViewStore } from '@vt/hooks'
import ContainerRender from '../tables/container/container-render'
import DataOperateProvider from '../tables/data-operate/DataOperateProvider'
import { useAfterTransform } from './hooks/afterTransform'
import { useDefsInjector } from './hooks/defsInjector'
import Operate from './operate'

const List = function ({ clickedId, refreshTree }) {
  const beforeTransform = useBeforeTransform({})
  const afterTransform = useAfterTransform()
  const { sorts, layouts, setFilters, showRecycle, showOperation } =
    useTbViewStore((state) =>
      pick(state, [
        'sorts',
        'layouts',
        'setFilters',
        'showRecycle',
        'showOperation',
      ])
    )

  useEffect(() => {
    if (clickedId) {
      const filters = {
        logicType: 'and',
        queries: [
          {
            slug: 'parentId',
            value: clickedId,
            queryType: ['like'],
          },
        ],
      }
      setFilters(filters, true)
    } else {
      const filters = {
        logicType: 'and',
        queries: [
          {
            slug: 'level',
            value: 1,
            queryType: ['equal'],
          },
        ],
      }
      setFilters(filters, true)
    }
  }, [clickedId, showOperation])

  useDefsInjector(false)

  const showLayouts = showRecycle ? layouts.recycleLayouts : layouts.layouts

  // 列表以childOrder排序时才展示排序按钮
  const canSort =
    Array.isArray(sorts) && sorts.some((s) => s.slug === 'childOrder')

  return (
    <div className="h-full">
      <DataOperateProvider refreshTree={refreshTree} isDraggable={canSort}>
        <div className="flex flex-col h-full">
          {get(showLayouts, 'elements', [])
            .filter((element) => !element.hidden)
            .map((element, index) => {
              return (
                <ContainerRender
                  key={`${element}-${index}`}
                  layouts={element}
                  beforeTransform={beforeTransform}
                  afterTransform={afterTransform}
                  autoFetchData={false}
                  CustomOperateComponent={Operate}
                />
              )
            })}
        </div>
      </DataOperateProvider>
    </div>
  )
}

export default List
